module.exports = __webpack_public_path__ + "static/media/menuMic.24b7aa75.svg";